import { render, staticRenderFns } from "./Cgu.vue?vue&type=template&id=f68e9466&scoped=true"
import script from "./Cgu.vue?vue&type=script&lang=ts"
export * from "./Cgu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68e9466",
  null
  
)

export default component.exports